import type { TPermission } from '@semios/app-platform-value-type-definitions'
import { CREATE_REPORT_PESTS_DEGREE_DAYS_ID_insectId } from '@semios/app-platform-value-type-definitions'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TProperty } from 'stores/fieldAssetStore/helperTypes'
import { checkAuthorization } from 'utils/checkAuthorization'

const WEEKLY_UPDATE_SECTION_PERMISSIONS: TPermission[] = [
  'CREATE_REPORT_WEATHER',
  'CREATE_REPORT_FIRE_BLIGHT',
  'CREATE_REPORT_EVAPOTRANSPIRATION',
  'CREATE_REPORT_IRRIGATION_ACTIVITY',
  'CREATE_REPORT_SOIL_MOISTURE',
  'CREATE_REPORT_CHILL',
  'CREATE_REPORT_POLLINATION',
  'CREATE_REPORT_GROWING_DEGREE_DAYS',
]

// Pest Control only shows a pest whose degree days permission passes, so trap catches alone add no section
export const getPermittedWeeklyUpdateReportProperties = (
  properties: TProperty[],
  insects: TFieldAssetStoreState['insects'],
) => {
  const permissions = [
    ...WEEKLY_UPDATE_SECTION_PERMISSIONS,
    ...Object.values(insects ?? {}).map(({ insectId }) =>
      CREATE_REPORT_PESTS_DEGREE_DAYS_ID_insectId(insectId),
    ),
  ]

  return properties.filter((property) =>
    checkAuthorization(permissions.map((permission) => ({ permission, entity: property.propertyId }))),
  )
}
